import React from 'react';

import EmptyApple from '~/src/screens/Landing/images/apple-empty.svg';
import Apple from '~/src/screens/Landing/images/apple.svg';

import { PropsFromInputs } from '../../types';

import { ApplesContainer, ItemContainer } from './layout';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ currentStep, totalSteps, order, reward, conditions }: Props) => {
  const hasSteps = currentStep && totalSteps;

  const FullApples = () => (currentStep ? Array(currentStep).fill(<Apple />) : null);
  const EmptyApples = () =>
    hasSteps ? Array(totalSteps - currentStep).fill(<EmptyApple />) : null;

  return (
    <ItemContainer>
      {hasSteps ? (
        <ApplesContainer>
          <FullApples />
          <EmptyApples />
        </ApplesContainer>
      ) : null}
      <p>{order}</p>
      <p>{reward}</p>
      {conditions ? <p>{conditions}</p> : null}
    </ItemContainer>
  );
};
